import * as tslib_1 from "tslib";
import { Component, Watch } from "vue-property-decorator";
import { FileUploadControl } from "../../../src/common/controls/file-upload-control";
import { FormLocationControl } from "../../../src/common/controls/form-location-control";
import { UploadStatus, } from "../../../src/common/controls/upload-control";
// import { UploadFile } from "../../../common/controls/upload-control";
import common from "../../../../common/mobile";
import { H3Upload, H3Dialog, H3Avatar } from "h3-mobile-vue";
import axios from "axios";
import { Button, Icon, Modal, Upload } from "@h3/antd-vue";
const suffix = ".jpg";
let UploadMobile = class UploadMobile extends FileUploadControl {
    constructor() {
        super(...arguments);
        this.uploadUrlMobile = "#";
        this.fileList = [];
        this.isAddWatermark = false;
        this.locationInfo = "";
        this.changing = false;
        this.showSignsture = false;
        this.filePreviewUrl = "";
        this.precents = [];
        this.status = []; // 保存单个文件状态
        this.timer = 0;
        this.eventList = [];
        this.batchFileList = [];
        this.uploadFileList = [];
        this.largeUploadUrl = "";
        this.largeUploadHeaders = {};
    }
    // 打开表单的时候
    mounted() {
        // 如果仅拍照上传且有水印 就使用钉钉去定位
        this.isAddWatermark = !!this.controlOpts.addWatermark;
        if (!this.readonly) {
            this.getLoaction();
        }
    }
    showTip() {
        return false;
    }
    get listType() {
        // 子表中图片上传显示成附件上传样式
        return this.isImage && !this.control.parentKey ? "picture-card" : "text";
    }
    get isOpenPreview() {
        return !this.getIsOpenPreview();
    }
    showLoading(text) {
        this.$h3.toast.show({
            text,
            autoHide: false,
            iconType: "loading",
        });
    }
    showError(text) {
        this.$h3.toast.show({
            text,
            autoHide: true,
            iconType: text.length < 8 ? "close" : "",
        });
    }
    showSuccess(text) {
        this.$h3.toast.show({
            text,
            autoHide: true,
            iconType: "check",
            duration: 1000,
        });
    }
    showInfo(text) {
        this.$h3.toast.show({
            text: text,
        });
        // (this as any).$h3.toast.show({
        //   text,
        //   autoHide: true,
        //   iconType: "info",
        //   duration: 1000,
        // });
    }
    hideToast() {
        this.$h3.toast.hide();
    }
    eventListChange(arr = []) {
        // 跟新文件上传进度
        if (arr && arr.length > 0) {
            this.autoStep();
        }
    }
    /**
     * @des 模拟更新进度条
     */
    autoStep() {
        // 防止开启多个定时器
        clearTimeout(this.timer);
        let isRpeat = false;
        this.precents = this.eventList.map((item, i) => {
            let { status, percent = 0, timer = -1, size = 0, response } = item;
            status = this.transformStatus(status);
            percent = this.getPercent(i);
            let step = 0;
            let ss = 300; // 默认每秒钟300k的上传速度
            if (status === "done" || status === "error") {
                percent = 100;
            }
            else {
                step = 100 / (size / ss / 1024);
                percent = percent + step;
                isRpeat = true;
            }
            // 状态更新
            if (response && !response.data) {
                status = "error";
            }
            return { percent, status };
        });
        // 调用自己
        if (isRpeat) {
            this.timer = window.setTimeout(this.autoStep, 1000);
        }
    }
    handleValueChange(value) {
        // 图片有两种情况,
        // 上传图片和被动赋值.
        // 如果是主动上传图片则不应该 调用this.toFilelist.
        // 如果是赋值则可以调用this.toFilelist. 目前看来每次更新赋值前 value会被设置null.
        if (!value) {
            this.toFilelist(value);
        }
        else if (value.length &&
            (!this.uploadFileList || this.uploadFileList.length === 0)) {
            this.toFilelist(value);
        }
        else if (value && value.length >= 0) {
            this.toFilelist(value);
        }
        else if (value.length === this.uploadFileList.length) {
        }
    }
    setControl() {
        if (this.ctrl && this.ctrl.value) {
            this.toFilelist(this.ctrl.value);
        }
        else {
            // this.fileList = [];
            this.uploadFileList = this.fileList = [];
        }
        this.unsubscribe();
        this.listenCommand();
    }
    toFilelist(val) {
        if (!val) {
            this.uploadFileList = this.fileList = [];
            return;
        }
        //说明此时的数据还未经过转换
        if (Array.isArray(val) && val.length > 0 && val[0].mimeType) {
            val = this.convertFileData(val);
            if (!val)
                return;
        }
        this.uploadFileList = this.fileList = val.map((y) => {
            let x = "";
            if (!y.uid && y.response && y.response.data) {
                x = y.response.data;
            }
            else {
                x = y;
            }
            if (x.response && x.response.data) {
                x.url = x.url || "";
                x.previewUrl = x.previewUrl || "";
            }
            return x;
        });
    }
    listenCommand() {
        const _this = this;
        this.commandSubscription = this.ctrl.commander.subscribe((cmd) => {
            switch (cmd.name) {
                case "clear":
                    _this.fileList = [];
                    _this.ctrl.value = null;
                    break;
                default:
                    break;
            }
        });
    }
    getLoaction() {
        if (this.isAddWatermark) {
            FormLocationControl.service.position(undefined, false).then((result) => {
                this.locationInfo = result.address;
            });
        }
    }
    beforeUpload(file) {
        if (!this.checkFileType(file.name, this.showError)) {
            return false;
        }
        if (!this.checkImageNumber(this.showError)) {
            return false;
        }
        if (!this.checkImageNameLength(file.name, this.showError)) {
            return false;
        }
        file.uploadTime = new Date().getTime();
        let userInfo = window.sessionStorage.getItem("user");
        if (userInfo) {
            userInfo = JSON.parse(userInfo);
        }
        else {
            userInfo = { name: "" };
        }
        file.uploadName =
            window.sessionStorage.getItem("uploadName") || userInfo.name;
        return true;
    }
    get isReadonly() {
        if (this.ctrl) {
            return this.readonly;
        }
        return true;
    }
    uploadListType(name) {
        let typeArr = name.split(".");
        let type = typeArr[typeArr.length - 1].toUpperCase();
        let t = "";
        switch (type) {
            case "JPG":
            case "PNG":
            case "JPEG":
            case "GIF":
                t = "#h-icon-all-picture";
                break;
            case "DOC":
            case "DOCX":
                t = "#h-icon-all-word";
                break;
            case "EXL":
            case "EXLX":
            case "XLSX":
            case "XLS":
            case "XLSM":
                t = "#h-icon-all-excel";
                break;
            case "PPT":
            case "PPTX":
                t = "#h-icon-all-ppt";
                break;
            case "ZIP":
            case "RAR":
                t = "#h-icon-all-zip";
                break;
            case "TXT":
                t = "#h-icon-all-t";
                break;
            case "PDF":
                t = "#h-icon-all-pdf";
                break;
            case "AUD":
                t = "#h-icon-all-music";
                break;
            case "VID":
                t = "#h-icon-all-video";
                break;
            default:
                t = "#h-icon-all-unkonw";
        }
        return t;
    }
    getfileSize(size) {
        return size > 1048576
            ? Math.round((100 * size) / 1048576) / 100 + "MB"
            : Math.round((100 * size) / 1024) / 100 + "KB";
    }
    getPercent(key) {
        let res = this.precents[key];
        if (!res)
            return 0;
        return res.percent;
    }
    getStatus(key) {
        if (!this.precents.length)
            return "done";
        let status = this.precents[key];
        if (status && status.status) {
            return this.transformStatus(status.status);
        }
        return "";
    }
    transformStatus(status) {
        switch (status) {
            case UploadStatus.Delete:
                return "removed";
            case UploadStatus.Uploading:
                return "uploading";
            case UploadStatus.Done:
                return "done";
            case UploadStatus.Error:
                return "error";
            case UploadStatus.FileToImg:
                return "fileToImg";
            default:
                return status;
        }
    }
    blobToBase64(blob, callback) {
        var reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = function (e) {
            callback(e.target.result);
        };
    }
    getImgUrl(item) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (item.status === 2 || item.status === "done") {
                if (!item.uid)
                    return;
                let url1 = "/api/oss/download/signurl";
                let params1 = {
                    refId: item.uid,
                };
                let res1 = yield axios.post(url1, params1);
                let downloadUrl = res1.data.signUrl;
                let imgUrl = "";
                return downloadUrl;
                // axios({
                //   url: downloadUrl,
                //   method: "get",
                //   responseType: "blob",
                // }).then((res: any) => {
                //   this.blobToBase64(res, function (result: any) {
                //     imgUrl = result;
                //     return imgUrl;
                //   });
                // });
            }
            else {
                return "";
            }
        });
    }
    handleUploadFile(file) {
        const _super = name => super[name];
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let flag = this.beforeUpload(file.file);
            if (flag === false)
                return false;
            let url1 = "/api/oss/upload/signurl";
            let headers = {};
            let param1 = {
                fileName: file.file.name,
                fileSize: file.file.size,
            };
            let res1 = yield axios.post(url1, param1, { headers });
            if (res1.errcode !== 0) {
                return false;
            }
            // 'Content-Type': 'multipart/form-data'
            let uploadHeaders = Object.assign({}, res1.data.headers, res1.data.metaData);
            let { refId, signUrl } = res1.data;
            // file.uid = refId;
            // 上传
            let res2 = yield axios.put(signUrl, file.file, { headers: uploadHeaders });
            // 通知租户上传成功
            let url3 = "/api/oss/upload/success";
            let param3 = { refId: res1.data.refId };
            let res3 = yield axios.post(url3, param3);
            if (res3.errcode !== 0) {
                return;
            }
            else {
                let newFile = file.file;
                newFile.response = res3;
                newFile.percent = 100;
                newFile.status = "done";
                // newFile.uid = refId;
                this.batchFileList.push(newFile);
                // 保存文件上传进度
                this.eventList = this.uploadFileList = this.uploadFileList.map((f) => {
                    const obj = this.batchFileList.filter((v) => {
                        if (v.uid === f.uid) {
                            return v;
                        }
                    });
                    return obj && obj.length > 0 ? obj[0] : f;
                });
                this.fileList = this.fileList.map((f) => {
                    const obj = this.batchFileList.filter((v) => {
                        if (v.uid === f.uid) {
                            return v;
                        }
                    });
                    return obj && obj.length > 0 ? obj[0] : f;
                });
                const files = this.fileList
                    .filter((f) => f.status &&
                    !(f.status === "removed" || f.status === UploadStatus.Delete))
                    .map((f) => {
                    const obj = this.batchFileList.filter((v) => {
                        if (v.uid === f.uid) {
                            return v;
                        }
                    });
                    if (obj && obj.length > 0) {
                        f = obj[0];
                    }
                    let status = UploadStatus.Uploading;
                    switch (f.status) {
                        case "done":
                            status = UploadStatus.Done;
                            break;
                        case "error":
                            status = UploadStatus.Error;
                            break;
                        case "uploading":
                            status = UploadStatus.Uploading;
                            break;
                        default:
                            status = f.status;
                            break;
                    }
                    return {
                        uid: f.uid,
                        name: f.name,
                        size: f.size,
                        type: f.type,
                        status: status,
                        response: f.response,
                        url: "",
                        uploadTime: f.uploadTime,
                        uploadName: f.uploadName,
                    };
                });
                _super("onFilesChange").call(this, files);
            }
        });
    }
    // onChange 上传结束时不会调用onChange
    onChange(info) {
        let flag = this.beforeUpload(info.file);
        if (flag === false)
            return;
        clearTimeout(this.timer);
        if (this.isReadonly) {
            return;
        }
        this.uploadFileList = info.fileList.filter((f) => f.status && f.status !== "removed");
        if (this.uploadFileList.length === 0) {
            return;
        }
        //保存文件状态
        let { file } = info;
        const status = info.file.status;
        if (status === "done" && file.response && file.response.errcode === 0) {
            this.batchFileList.push(file);
        }
        // 保存文件上传进度
        this.eventList = this.uploadFileList = this.uploadFileList.map((f) => {
            if (f.response && f.response.errcode === 50000) {
                f.status = UploadStatus.Error;
            }
            const obj = this.batchFileList.filter((v) => {
                if (v.uid === f.uid) {
                    return v;
                }
            });
            return obj && obj.length > 0 ? obj[0] : f;
        });
        const files = info.fileList
            .filter((f) => f.status &&
            !(f.status === "removed" || f.status === UploadStatus.Delete))
            .map((f) => {
            // 有服务errorcode = 50000 但是上传状态返回为done的情况 估计是上传接口先上传到服务器  再通过ftp还是oss转移到其他地方
            const obj = this.batchFileList.filter((v) => {
                if (v.uid === f.uid) {
                    return v;
                }
            });
            if (obj && obj.length > 0) {
                f = obj[0];
            }
            let status = UploadStatus.Uploading;
            switch (f.status) {
                case "done":
                    status = UploadStatus.Done;
                    break;
                case "error":
                    status = UploadStatus.Error;
                    break;
                case "uploading":
                    status = UploadStatus.Uploading;
                    break;
                default:
                    status = f.status;
                    break;
            }
            return {
                uid: f.uid,
                name: f.name,
                size: f.size,
                type: f.type,
                status: status,
                response: f.response ? f.response : "",
                // response: f.response,
                url: "",
                uploadTime: f.uploadTime,
                uploadName: f.uploadName,
            };
        });
        super.onFilesChange(files);
        this.fileList = info.fileList.map((f) => {
            const obj = this.batchFileList.filter((v) => {
                if (v.uid === f.uid) {
                    return v;
                }
            });
            return obj && obj.length > 0 ? obj[0] : f;
        });
    }
    onRemovedImg(file) {
        super.removedFile(file);
    }
    previewFile(item) {
        if (item.status === 2 || item.status === "done") {
            this.handlePreview(item);
        }
    }
    isImageFileType(filename) {
        const imageExtensions = [
            ".jpg",
            ".jpeg",
            ".png",
            ".gif",
            ".bmp",
            ".svg",
            ".webp",
        ];
        const fileExtension = filename.slice(filename.lastIndexOf("."));
        return imageExtensions.includes(fileExtension.toLowerCase());
    }
    joyChatOpenPDF(fileName, filePath) {
        console.log("大附件 showFile " + fileName);
        console.log("大附件 showFile " + filePath);
        //判断是否是joychat端
        const IS_JOYCHAT = /workplus/.test(navigator.userAgent);
        if (window.cordova && IS_JOYCHAT) {
            window.cordova.exec(function (result) {
                console.log(result);
            }, function (error) {
                console.log(error);
            }, "WorkPlus_Files", "showFile", [
                {
                    filePath: filePath,
                    fileName: fileName,
                    isImage: this.isImageFileType(fileName) ? true : false,
                },
            ]);
        }
    }
    handlePreview(item) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.showSignsture = false;
            if (item.previewUrl) {
                this.showSignsture = true;
                this.filePreviewUrl = item.previewUrl;
                // platform.service.openLink(item.previewUrl);
            }
            else {
                let url1 = "/api/oss/download/signurl";
                let params1 = {
                    refId: item.response.data.refId,
                };
                let res1 = yield axios.post(url1, params1);
                let downloadUrl = res1.data.signUrl;
                let type = item.type || item.response.data.mimeType;
                if ((type &&
                    (type.indexOf("image") !== -1 ||
                        type.toUpperCase().indexOf("PDF") !== -1)) ||
                    (!type && this.isImageFileType(item.name))) {
                    // this.showSignsture = true;
                    this.joyChatOpenPDF(item.name, downloadUrl);
                    // this.filePreviewUrl = downloadUrl;
                    // platform.service.openLink(downloadUrl);
                }
                else {
                    this.showInfo("Unable to preview this file, please download and view");
                    return;
                }
            }
        });
    }
    downloadMobileFile(item) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (item.status === 2 || item.status === "done") {
                //根据refId 获取 下载url
                let url1 = "/api/oss/download/signurl";
                let params1 = {
                    refId: item.response.data.refId,
                };
                let res1 = yield axios.post(url1, params1);
                let downloadUrl = res1.data.signUrl;
                //判断是否是joychat端
                const IS_JOYCHAT = /workplus/.test(navigator.userAgent);
                if (window.cordova && IS_JOYCHAT) {
                    window.cordova.exec(function (result) {
                        alert(JSON.stringify(result, null, 4));
                    }, function (error) {
                        alert("调⽤失败");
                    }, "WorkPlus_Files", "showFile", [
                        {
                            filePath: downloadUrl,
                            fileName: item.name,
                            fileSize: item.size,
                            isImage: item.response.data.mimeType.indexOf("image") > -1
                                ? true
                                : false,
                        },
                    ]);
                }
                else {
                    // let val = this.downUrls[idx];
                    axios({
                        url: downloadUrl,
                        method: "get",
                        responseType: "blob",
                    }).then((res) => {
                        let binaryData = [];
                        // binaryData.push(res.data);
                        // const url = window.URL.createObjectURL(new Blob(binaryData,{type:'application/octet-stream'}));
                        // let downloadName = file.name;
                        this.downloadFileUtil(item.name, res);
                    });
                    event && event.stopPropagation();
                    let h3form = window.h3form;
                    if (h3form.formObj.bizObject.schemaCode === "createOfferProposal" &&
                        (h3form.status.value === "SAP Informed" ||
                            h3form.status.value === "SAP Updated")) {
                        window.h3form.status.value = "SAP Updated";
                    }
                }
            }
        });
    }
    downloadFileUtil(fileName, content) {
        const blob = new Blob([content]);
        // for IE
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileName.replace(new RegExp('"', "g"), ""));
        }
        else {
            const a = document.createElement("a");
            // 生成文件路径
            let href = window.URL.createObjectURL(blob);
            // let _fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
            a.href = href;
            // 文件名中有中文 则对文件名进行转码
            a.download = decodeURIComponent(fileName.replace(new RegExp('"', "g"), ""));
            // 利用a标签做下载
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(href);
        }
    }
    removeFileBefore(file, key) {
        // financial 模块要求删除附件时弹框确认
        let financialForm = window.h3form.formObj.bizObject.schemaCode;
        if (financialForm === "purchase_Request" ||
            financialForm === "payment_application" ||
            financialForm === "travelRequest" ||
            financialForm === "travel_expense_claim" ||
            financialForm === "local_travel_claim" ||
            financialForm === "entertainment_requests" ||
            financialForm === "entertainment_Expense_C" ||
            financialForm === "special_approval_request" ||
            financialForm === "marketing_pr" ||
            financialForm === "chop_application" ||
            financialForm === "fixed_asset_application") {
            window.h3form.$confirm({
                title: "Confirm Dialog",
                content: `Are you sure you want to delete this file:${file.name}?`,
                onOk: () => {
                    this.removedFile(file);
                },
            });
        }
        else {
            this.removedFile(file);
        }
    }
    removedFile(file) {
        const res = Object.assign({}, file, { status: UploadStatus.Delete }) || null;
        this.uploadFileList = this.uploadFileList.filter((u) => u.uid !== file.uid);
        super.removedFile(file);
    }
    uploadError(err) {
        if (!err) {
            return;
        }
        let msg = "";
        switch (err) {
            // case 'overQuantity':
            //   this.showError(`一次最多允许上传张`);
            //   break;
            // case 'uploadError':
            //   this.showError(`文件错误`);
            //   break;
            case "overSize":
                msg = this.$t("cloudpivot.form.renderer.tip.overSize", {
                    label: this.limitSize,
                }).toString();
                this.showError(msg);
                break;
            default:
                msg = this.$t("cloudpivot.form.renderer.tip.uploadError").toString();
                this.showError(msg);
                // this.showError('上传失败请重试');
                break;
        }
    }
    destroyed() {
        super.destroyed();
        if (this.commandSubscription) {
            this.commandSubscription.unsubscribe();
        }
    }
    created() {
        this.init();
    }
    hideSignsture() {
        this.showSignsture = false;
    }
};
tslib_1.__decorate([
    Watch("eventList")
], UploadMobile.prototype, "eventListChange", null);
UploadMobile = tslib_1.__decorate([
    Component({
        name: "upload",
        components: {
            H3Upload,
            H3Dialog,
            H3Avatar,
            AIcon: Icon,
            AButton: Button,
            AUpload: Upload,
            AModal: Modal,
        },
        directives: {
            TransferDom: common.directives.transferDom,
        },
    })
], UploadMobile);
export default UploadMobile;
